<template>
	<div class="left">
		<div class="item">
			<div class="biglinebox">
				<div class="biglineball"></div>
			</div>
			<div class="le_box" @click="lefun(0)">
				<img class="l1_img1" src="@/static/home/fast-icon1.png" alt="" />
				<div class="le_name">
					<span v-if="lang==0">V R全景</span>
					<span v-if="lang==1">V Rpanorama</span>
					<span v-if="lang==2">V Rパノラマ</span>
					<span v-if="lang==3">V R파노라마</span>
				</div>
			</div>
		</div>
		<div class="item">
			<div class="biglinebox">
				<div class="biglineball"></div>
			</div>
			<div class="le_box" @click="lefun(1)">
				<img class="l1_img2" src="@/static/home/fast-icon2.png" alt="" />
				<div class="le_name">
					<span v-if="lang==0">新闻动态</span>
					<span v-if="lang==1">News</span>
					<span v-if="lang==2">新闻动态</span>
					<span v-if="lang==3">新闻动态</span>
				</div>
			</div>
		</div>
		<div class="item">
			<div class="biglinebox">
				<div class="biglineball"></div>
			</div>
			<div class="le_box" @click="lefun(2)">
				<img class="l1_img3" src="@/static/home/fast-icon3.png" alt="" />
				<div class="le_name">
					<span v-if="lang==0">咨询热线</span>
					<span v-if="lang==1">consult Hotline</span>
					<span v-if="lang==2">コンサルティング ねっせん</span>
					<span v-if="lang==3">컨설팅 핫라인</span>
				</div>
			</div>
			<div class="le-info">
				{{this.$store.state.advice}}
			</div>
		</div>
		<div class="item">
			<div class="biglinebox">
				<div class="biglineball"></div>
			</div>
			<div class="le_box" @click="lefun(3)">
				<img class="l1_img4" src="@/static/home/fast-icon4.png" alt="" />
				<div class="le_name">
					<span v-if="lang==0">在线预定</span>
					<span v-if="lang==1">在线预定</span>
					<span v-if="lang==2">在线预定</span>
					<span v-if="lang==3">在线预定</span>
				</div>
			</div>
		</div>
		<div class="item">
			<div class="biglinebox">
				<div class="biglineball"></div>
			</div>
			<div class="le_box" @click="lefun(4)">
				<img class="l1_img5" src="@/static/home/fast-icon5.png" alt="" />
				<div class="le_name">
					<span v-if="lang==0">扫码体验</span>
					<span v-if="lang==1">扫码体验</span>
					<span v-if="lang==2">扫码体验</span>
					<span v-if="lang==3">扫码体验</span>
				</div>
				<div class="erbox">
					<img class="all_img" src="@/static/home/qrcode.png" alt="" />
				</div>
			</div>
		</div>
	</div>
</template>

<script>
	export default {
		data() {
			return {
				elf:false,
				lang: 0,
			}
		},
		created(){
			this.lang = JSON.parse(localStorage.getItem("langs")) || 0;
		},
		methods:{
			lefun(e){
				if(e==0){
					window.open("https://www.720yun.com/vr/486j57uvun2")
				}
				if(e==1){
					this.$router.push({name:'trends',query:{index:5}})
				}
				if(e==2||e==4){
					this.elf = !this.elf
				}
				if(e==3){
					this.$router.push({name:'online',query:{index:6}})
				}
			},
		}
	}
</script>

<style scoped lang="less">
	.left{
		position: fixed;
		top: 50%;
		left: 0;
		transform: translateY(-50%);
		z-index: 100;
	}
	.item{
		display: flex;
		align-items: center;
	}
	.item:hover{
		.biglinebox {
		    width: 5vw;
		}
		.erbox,.le-info{
			display: block;
		}
	}
	.biglinebox {
	    width: 2vw;
	    border-bottom: 1px dashed #fff;
	    display: flex;
	    justify-content: center;
	    align-items: center;
	    height: 2px;
	    transition: all .6s;
	}
	.biglineball {
	    width: .3vw;
	    height: .3vw;
	    border-radius: 50%;
	    background-color: #fff;
	    margin-top: 2px;
	}
	.le_box{
		padding: 20px;
		border-radius: 20px;
		background-color: rgba(0, 0, 0, .5);
		box-sizing: border-box;
		color: #fff;
		display: flex;
		flex-direction: column;
		justify-content: center;
		align-items: center;
		margin-bottom: 13px;
		position: relative;
	} 
	
	.l1_img1{
		width: 34px;
		height: 22px;
	}
	.l1_img2{
		width: 29px;
		height: 27px;
	}
	.l1_img3{
		width: 30px;
		height: 27px;
	}
	.l1_img4{
		width: 27px;
		height: 26px;
	}
	.l1_img5{
		width: 26px;
		height: 26px;
	}
	.le_name{
		margin-top: 5px;
		font-size: 14px;
	}
	.erbox{
		width: 100px;
		height: 100px;
		background-color: #fff;
		position: absolute;
		right: -110px;
		top: 50%;
		transform: translateY(-50%);
		display: none;
	}
	.le-info{
		padding: 10px;
		font-size: 14px;
		color: #fff;
		background-color: rgba(0, 0, 0, .5);
		position: absolute;
		right: -120px;
		top: 50%;
		border-radius: 5px;
		transform: translateY(-50%);
		display: none;
	}
	
</style>